export default "__VITE_ASSET__C8OJiU69__"